export default function reducer(state = {
  outlet: {
    id: '',
    customer_number: '',  
  },
  incentive: {
    id: '',
    name: '',
    start_date: '',
    end_date: '',  
  },
  staff_reward_allocations: [],
  fetching: false,
  fetched: false,
  errors: {},
}, action) {
  switch (action.type) {
    case 'GET_OUTLET_REWARD_ALLOCATIONS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false
      }
    }
    case 'GET_OUTLET_REWARD_ALLOCATIONS_FULFILLED': {
      const data = action.payLoad.data;

      return {
        ...state,
        fetching: false,
        fetched: true,
        outlet: { id: data.attributes['outlet-id'], customer_number: data.attributes['customer-number'] },
        incentive: {
          id: data.attributes['incentive-id'],
          name: data.attributes['incentive-name'],
          startDate: data.attributes['incentive-start-date'],
          endDate: data.attributes['incentive-end-date'],  
        },
        outletRewardAllocations: data.attributes['staff-reward-allocations']
      }
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/outletRewardAllocationsReducer.js